import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { SIGNATURE_ACTUALISER_OFFRE_GUY } from '../../apiEndPoints';
import {
    axiosInstance,
    reactQueryOptions,
    IMutationResult,
    getDynamicHeaders
} from '../../../../api';

const putActualiserOffreGuy = async (
    idDemande: number
): Promise<AxiosResponse<any>> => {
    const endPoint = SIGNATURE_ACTUALISER_OFFRE_GUY.replace(
        /{idDemande}/g,
        String(idDemande)
    );

    const { data: response } = await axiosInstance.put(
        endPoint,
        {},
        await getDynamicHeaders()
    );

    return response;
};

export const useActualiserOffreGuyApi = (): IMutationResult => {
    return useMutation(putActualiserOffreGuy, {
        ...reactQueryOptions()
    });
};
